import { Component, OnInit, ElementRef, ViewChild, Signal, signal } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { HttpEvent, HttpEventType } from "@angular/common/http";
import { Router } from "@angular/router";
import { trigger, transition, style, animate } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { SystemConfigService } from './../system-config/system-config.service';
import { environment } from "../../../../../environments/environment";
import { StorageService } from 'src/app/core/helpers/storage.service';
import { AuthService } from "src/app/core/auth/auth.service";
import { AlertService } from "src/app/core/alert/alert.service";
import { PaginationService } from "src/app/core/pagination.service";
import { ValidationService } from "src/app/core/validation.service";
import { LanguageService } from 'src/app/core/translate/language.service';
import { UserDetails } from 'src/app/pages/shared/models/responses/user-details';
import { Client } from '../manage-banks/models/clients-models';
import { ClientService } from '../shared/services/client.service';
import { OEM } from '../oem-management/models/oem';
import { OemService } from '../oem-management/services/oem.service';
import { CsvService } from '../manage-devices/services/csv.service';
import { FormUtilsService } from "src/app/pages/shared/services/formUtils.service";
import { Subscription } from "rxjs";




declare var $: any;

@Component({
  standalone: false,
  selector: 'app-manage-apps',
  templateUrl: './manage-apps.component.html',
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(70%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('1500ms', style({ transform: 'translateY(70%)', opacity: 0 }))
      ])
    ]
    )
  ],
  styleUrls: ['./manage-apps.component.scss']
})
export class ManageAppsComponent implements OnInit {
  @ViewChild("setPageSizeId", { static: true }) setPageSizeId: ElementRef;

  showFilter: boolean;
  isLoading: boolean;
  isRefreshing = false;
  isCSVLoading: boolean;
  isAppCreating = false;
  filesToUpload: any;
  fileName: string = "";
  fileSize: string = "";
  selectedApp: any;
  isDeleting = false;
  allAppVersions: any = [];
  allAppsReports: any = [];
  appLogo: any;
  logoName: string = "";
  uploadProgress: number = 0;
  isChecked: any = false
  uploadSubscription: Subscription;

  dataCount: number = 0;
  searchForm: UntypedFormGroup;
  createAppForm: UntypedFormGroup;
  editAppForm: UntypedFormGroup;
  newVersionForm: UntypedFormGroup;
  showVersionForm = false;

  pager: any = [];
  permissions: any[] = [];
  pagedItems: any;
  pageIndex: number = environment.PageIndex;
  pageSize: number = environment.PageSize;
  pages: any;
  currentPage: any;
  validationMessage: any;
  allApps: any = [];
  selectedBusiness: any;
  editing = "";
  selectedValue: any = [];
  userRole: any = '';
  platformId: string;
  userDetails = this.storageService.getCurrentUser()?.user;
  clients = this.clientService.clients;
  isFiltered: boolean = false;
  allOem: OEM[] = [];
  selectedLang: string;
  isFetchingVersions: boolean = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private paginationService: PaginationService,
    private alertService: AlertService,
    validationMessages: ValidationService,
    private sysConfig: SystemConfigService,
    private router: Router,
    private authService: AuthService,
    private storageService: StorageService,
    private clientService: ClientService,
    private oemService: OemService,
    private languageService: LanguageService,
    public translate: TranslateService,
    private csvService: CsvService,
    private formUtils: FormUtilsService
  ) {
    this.validationMessage = validationMessages;
    this.initializeForm();
    this.showFilter = false;
    this.isLoading = true;
    this.pages = [];
    this.currentPage = 1;
    this.getAllApps();
    this.checkUserType();
    this.languageService.language$.subscribe(res => {
      this.selectedLang = res;
      this.translate.setDefaultLang(this.selectedLang);
      this.translate.use(this.selectedLang);
    });
  }

  ngOnInit() {
    if (this.userDetails.userRole === 'ROLE_SUPER_ADMIN') {
      this.isLoading = true;
      this.getPreviousVisitedPage();
    }
    this.getAllOEM();
  }

  initializeForm() {
    this.searchForm = this.formBuilder.group({
      appName: "",
    });
    this.createAppForm = this.formBuilder.group({
      appDesc: [""],
      clientId: [""],
      oemName: [""]
    });
    this.editAppForm = this.formBuilder.group({
      appName: [{ value: '', disabled: true }],
      appDesc: [""],
      displayName: ["", Validators.compose([Validators.required])],
      platformId: [{ value: '', disabled: true }],
      oemName: [""],
      clientId: [""],
    });
    this.newVersionForm = this.formBuilder.group({
      appDesc: [""],
      clientId: [""],
      oemName: [""]
    });
  }

  async getPermissions() {
    this.permissions = await this.authService.getPermissions();
  }

  checkUserType() {
    this.userRole = this.storageService.getCurrentUser()?.user.userRole;

  }
  getAllApps() {
    this.isLoading = true;
    this.getPreviousVisitedPage();
    this.sysConfig.getApps(this.pageIndex, this.pageSize, this.searchForm.value).subscribe(
      (res) => {
        this.allApps = res["data"];
        this.addIdToAllAppsResponse(this.allApps);
        if (res["totalElements"]) {
          this.dataCount = res["totalElements"];
        } else {
          this.dataCount = 0;
        }

        this.pager = this.paginationService.getPager(
          this.dataCount,
          this.currentPage,
          this.pageSize
        );

        this.pagedItems = this.allApps;

        this.isLoading = false;
        this.isRefreshing = false;
        this.showFilter = false;
      },
      (error) => {
        this.alertService.error(error);
        this.isLoading = false;
        this.isRefreshing = false;
        this.showFilter = false;
      }
    );
  }

  /**
   * Pagination and export section
   */
  reset() {
    this.isFiltered = false;
    this.isRefreshing = true;
    this.pageIndex = environment.PageIndex;
    this.showFilter = false;
    this.pageSize = environment.PageSize;
    this.setPageSizeId.nativeElement.value = environment.PageSize;
    this.searchForm.reset();
    this.currentPage = 1;
    this.getAllApps();
  }

  getPage(page) {
    this.isLoading = true;
    this.pageIndex = (page - 1)
    this.currentPage = page;
    this.storageService.storePageIndex(this.router.url, this.currentPage);
    this.getAllApps();
  }

  nextPage() {
    this.isLoading = true;
    this.currentPage++;
    this.pageIndex = this.currentPage - 1;
    this.storageService.storePageIndex(this.router.url, this.currentPage);
    this.getAllApps();
  }
  previousPage() {
    this.isLoading = true;

    this.currentPage--;
    this.pageIndex = this.currentPage - 1;
    this.storageService.storePageIndex(this.router.url, this.currentPage);

    this.getAllApps();
  }

  setPageSize(event: Event) {
    const size = (event.target as HTMLSelectElement).value;
    this.setPageSizeId.nativeElement.value = Number(size);
    this.isLoading = true;
    this.pageSize = Number(size);
    this.pageIndex = environment.PageIndex;
    this.currentPage = 1;
    this.getAllApps();
  }

  getPreviousVisitedPage() {
    if (!this.storageService.getPageIndex(this.router.url)) {
      this.storageService.storePageIndex(this.router.url, this.currentPage);
      return;
    } else {
      this.currentPage = this.storageService.getPageIndex(this.router.url);

      this.pageIndex = this.currentPage - 1;


    }

  }

  downloadAllData() {
    this.isCSVLoading = true;

    this.sysConfig.getApps(0, 1000000, this.searchForm.value).subscribe(
      (res) => {
        this.csvService.exportCSVFile(
          "Application List",
          [
            { appName: "APP NAME" },
            { appDesc: "APP DESCRIPTION" },
            { displayName: "DISPLAY NAME" },
          ],
          res["data"]
        );
        this.isCSVLoading = false;
      },
      (err) => {
        this.isCSVLoading = false;
        this.alertService.error(err, false);
      }
    );
  }

  downloadFilteredData() {
    this.csvService.exportCSVFile(
      "Application List",
      [
        { appName: "APP NAME" },
        { appDesc: "APP DESCRIPTION" },
        { displayName: "DISPLAY NAME" },
      ],
      this.allApps
    );
    this.isCSVLoading = false;
  }

  generateCSV() {
    if (this.isFiltered) {
      this.downloadFilteredData();
    } else {
      this.downloadAllData();
    }
  }
  /**
   * Pagination and export section
   */


  onSelectedFile(event) {
    if (event.target.files.length > 0) {
      this.filesToUpload = event.target.files[0];
      const sizeMB = (this.filesToUpload.size / (1024 * 1024)).toFixed(2);
      this.fileSize = `${sizeMB} MB`;
    }
    this.fileName = this.filesToUpload.name;
    event.target.value = "";
  }

  openSelector() {
    document.getElementById("input-file").click();
  }

  createApp() {
    this.isAppCreating = true;

    const appendFormData = (formData: FormData, key: string, value: any) => {
      formData.append(key, value !== null ? value : '');
    };

    const formData = new FormData();
    appendFormData(formData, "file", this.filesToUpload);
    appendFormData(formData, "appDesc", this.createAppForm.value.appDesc?.trim());
    appendFormData(formData, "appLogoFile", this.appLogo);
    appendFormData(formData, "clientId", this.createAppForm.value.clientId);
    appendFormData(formData, "oemName", this.createAppForm.value.oemName);

    this.uploadSubscription = this.sysConfig.createApp(formData).subscribe({
      next: (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.uploadProgress = Math.round((100 * event.loaded) / (event.total || 1));
        } else if (event.type === HttpEventType.Response) {
          this.isAppCreating = false;
          this.uploadProgress = 0;
          this.createAppForm.reset();
          this.getAllApps();
          $("#createApp").modal("hide");
          this.filesToUpload = {};
          this.fileName = "";
          this.fileSize = "";
          this.logoName = "";
          this.alertService.success("Application created successfully", true);
        }
      },
      error: (error) => {
        this.uploadProgress = 0;
        if (error.status !== 403) {
          this.isAppCreating = false;
          this.isLoading = false;
          this.createAppForm.reset();
          this.fileName = "";
          this.fileSize = "";
          this.logoName = "";
          this.getAllApps();
          $("#createApp").modal("hide");
          this.alertService.warn(error.error.responseMessage);
        } else {
          this.isAppCreating = false;
          this.isLoading = false;
          this.createAppForm.reset();
          this.fileName = "";
          this.fileSize = "";
          this.logoName = "";
          $("#createApp").modal("hide");
          this.alertService.warn(error.error.responseMessage);
          setTimeout(() => {
            this.alertService.error(error);
          }, 2000);
        }
      }
    });
  }


  updateApp() {
    this.isAppCreating = true;
    if (Object.keys(this.filesToUpload).length === 0 && this.filesToUpload.constructor === Object
    ) {
      this.updateAppDetails();
    } else {
      this.updateAppDetailsWithUpload();
    }
  }

  updateAppDetails() {
    this.isAppCreating = true;
    const appData = {};
    appData['appName'] = this.editAppForm.getRawValue().appName;
    appData['appDesc'] = this.editAppForm.value.appDesc;
    appData['displayName'] = this.editAppForm.value.displayName;
    appData['platformId'] = this.editAppForm.getRawValue().platformId;
    appData['clientId'] = this.editAppForm.value.clientId;
    appData['oem'] = this.editAppForm.value.oemName;

    const trimForm = this.formUtils.trimFormValues(appData);
    this.sysConfig.updateAppDetails(trimForm).subscribe(
      () => {
        this.isAppCreating = false;
        this.editAppForm.reset();
        this.getAllApps();
        $("#editApp").modal("hide");
        this.alertService.success("Application updated successfully", true);
      },
      (error) => {
        if (error.status !== 403) {
          this.isAppCreating = false;
          this.isLoading = false;
          this.getAllApps();
          $("#editApp").modal("hide");
          this.alertService.warn(error.error.responseMessage);
        } else {
          this.isAppCreating = false;
          this.isLoading = false;
          $("#editApp").modal("hide");
          this.alertService.warn(error.error.responseMessage);
          setTimeout(() => {
            this.alertService.error(error);
          }, 2000);
        }
      }
    );
  }

  onCheck(event) {
    if (event.target.checked) {
      this.isChecked = true;
    }
  }

  updateAppDetailsWithUpload() {
    this.isAppCreating = true;
    const formData = new FormData();
    formData.append("file", this.filesToUpload);
    formData.append("appDesc", this.selectedApp.appDesc);
    formData.append("appLogoFile", this.appLogo);
    formData.append("clientId", this.selectedApp.client.clientId);
    formData.append("oemName", this.selectedApp.oem.name);

    this.uploadSubscription = this.sysConfig.createApp(formData).subscribe({
      next: (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.uploadProgress = Math.round((100 * event.loaded) / (event.total || 1));
        } else if (event.type === HttpEventType.Response) {
          this.isAppCreating = false;
          this.uploadProgress = 0;
          this.editAppForm.reset();
          this.getAllAppsReport(this.selectedApp);
          this.showVersionForm = false;
          this.newVersionForm.reset();
          this.fileName = '';
          this.fileSize = '';
          this.logoName = '';
          this.filesToUpload = {};
          this.alertService.success("New version added successfully", true);
        }
      },
      error: (error) => {
        this.uploadProgress = 0;
        if (error.status !== 403) {
          this.isAppCreating = false;
          this.isLoading = false;
          this.getAllAppsReport(this.selectedApp);
          this.showVersionForm = false;
          this.newVersionForm.reset();
          this.fileName = '';
          this.fileSize = '';
          this.logoName = '';
          this.filesToUpload = {};
          this.alertService.warn(error.error.responseMessage);
        } else {
          this.isAppCreating = false;
          this.isLoading = false;
          this.alertService.warn(error.error.responseMessage);
          setTimeout(() => {
            this.alertService.error(error);
          }, 2000);
        }
      }
    });
  }

  cancelUpload() {
    if (this.uploadSubscription) {
      this.uploadSubscription.unsubscribe();
    }
    this.isAppCreating = false;
    this.uploadProgress = 0;
  }

  updateEditableApp(app) {
    this.filesToUpload = {};
    this.fileName = "";
    this.fileSize = "";
    this.editAppForm.patchValue(app);
    $("#editApp").modal("show");
  }

  warnUser(user) {
    this.selectedValue = user;
    $("#confirmationModal").modal("show");
  }

  deleteApp() {
    this.isDeleting = true;
    this.sysConfig.deleteApp(
      this.selectedValue.id,
      this.selectedApp.client.clientId
    ).subscribe({
      next: () => {
        this.isDeleting = false;
        this.createAppForm.reset();
        this.getAllAppsReport(this.selectedApp);
        $("#confirmationModal").modal("hide");
        this.alertService.success("Version deleted successfully", true);
      },
      error: (error) => {
        if (error.status !== 403) {
          this.isDeleting = false;
          this.isLoading = false;
          this.getAllAppsReport(this.selectedApp);
          $("#confirmationModal").modal("hide");
          this.alertService.warn(error.error.responseMessage);
        } else {
          this.isDeleting = false;
          this.isLoading = false;
          this.alertService.warn(error.error.responseMessage);
          setTimeout(() => {
            this.alertService.error(error);
          }, 2000);
        }
      }
    });
  }


  showEdit(app, desc, displayName) {
    this.editing = app.appName;
    this.filesToUpload = {};
    this.fileName = "";
    this.fileSize = "";
    this.editing = '';
    this.editAppForm.controls['appName'].setValue(app.appName);
    this.editAppForm.controls['appDesc'].setValue(desc);
    this.editAppForm.controls['displayName'].setValue(displayName);
    this.editAppForm.controls['platformId'].setValue(app.platformId);
    this.editAppForm.controls['clientId'].setValue(app.client.clientId);
    this.editAppForm.controls['oemName'].setValue(app.oem.name);
    $("#editApp").modal("show");
    this.isLoading = false;
    this.isRefreshing = false;
  }



  getAppVersions(app) {
    this.selectedApp = app;
    this.editing = app.appName;
    this.filesToUpload = {};
    this.fileName = "";
    this.fileSize = "";
    this.sysConfig.getApp(app.appName).subscribe(
      (res) => {
        this.allAppVersions = res;
        this.editing = '';
        this.newVersionForm.controls['appName'].setValue(app.appName);
        this.newVersionForm.controls['appDesc'].setValue(app.desc);
        this.newVersionForm.controls['displayName'].setValue(app.displayName);
        $("#showVersions").modal("show");
        this.isLoading = false;
        this.isRefreshing = false;
      },
      (error) => {
        this.alertService.error(error);
        this.editing = '';
        this.isLoading = false;
        this.isRefreshing = false;
      }
    );
  }

  getAllAppsReport(app) {
    this.selectedApp = app;
    this.editing = app.appName;
    this.filesToUpload = {};
    this.fileName = "";
    this.fileSize = "";
    this.platformId = app.platformId;
    this.isFetchingVersions = true;
    this.sysConfig.getAppsReport(app.appName, app.oem.name, 0, 100, app.client.clientId)
      .subscribe(
        (res) => {
          this.allAppsReports = res['data'];
          $("#showVersions").modal("show");
          this.editing = '';
          this.isFetchingVersions = false;
          this.isRefreshing = false;
        },
        (error) => {
          this.alertService.error(error);
          this.editing = '';
          this.isFetchingVersions = false;
          this.isRefreshing = false;
        }
      )
  }

  selectLogo(event) {
    if (event.target.files.length > 0) {
      this.appLogo = event.target.files[0];
    }
    this.logoName = this.appLogo.name;
    event.target.value = "";
  }

  filter() {
    this.isFiltered = true;
    this.getAllApps();
  }

  getAllOEM() {
    this.isLoading = true;
    this.getPreviousVisitedPage();
    this.oemService.getOemList(0, 1000).subscribe(
      (res) => {
        this.isLoading = false;
        this.isRefreshing = false;
        this.allOem = res["content"];
      },
      (error) => {
        if (error.status !== 403) {
          this.isLoading = false;
          this.isRefreshing = false;
          this.alertService.warn(error.error.responseMessage);
        } else {
          this.isLoading = false;
          this.isRefreshing = false;
          this.alertService.warn(error.error.responseMessage);
          setTimeout(() => {
            this.alertService.error(error);
          }, 2000);
        }
      }
    );
  }

  addIdToAllAppsResponse(array: any[]) {
    array.forEach((item, index) => {
      item.id = index + 1;
    });
  }
}
